/**
 * frec-web (frec.com) website sections
 * Used for anchor links: www.frec.com/#faq
 */

export enum HomePageAnchor {
  Interactive = "interactive",
  Press = "press",
  Testimonials = "testimonials",
  YourMoneyIsSecure = "your-money-is-secure",
  ExploreIndices = "explore-indices",
  DirectIndexCalculator = "direct-index-calculator",
  ComparisonTable = "compare",
  SophisticatedInvesting = "features",
  Treasury = "treasury",
  LearnMore = "resources",
  FAQ = "faq",
  ScheduleCall = "schedule-call",
}

export enum PricingPageAnchor {
  Comparison = "comparison",
  ExploreIndices = "explore-indices",
  BorrowRates = "borrow-rates",
}
